module.exports = __webpack_public_path__ + "media/src/images/icons/bell-62bbf34a82c71d6f4501a8c88f8ab73c.svg";